<template>
  <div>
    <b-row no-gutters>
      <b-col cols="12" md="3">
        <member-sidebar :route-name="$route.name" class="bg-dark" />
      </b-col>

      <b-col cols="12" md="9">
        <router-view />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";

import MemberSidebar from "@/components/Sidebar/Member/";

export default {
  name: "LayoutDesktop",
  components: { BRow, BCol, MemberSidebar },
  data: () => ({}),
};
</script>
